import React, { useContext } from 'react';
import {
  Typography,
  Box,
  Button,
  Paper,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import ReviewCards from './ReviewCards';
import Swal from 'sweetalert2';

const MotionPaper = motion.create(Paper);

const IssueReviews = ({ issue, reload, setReload }) => {
  const { currentUser } = useContext(AuthContext);
  const reviews = (!!issue && issue?.reviews) || [];
  const navigate = useNavigate();
  const { issueId } = useParams();

  // Extract unique report user IDs for this issue
  // const reportUserIds = (issue?.reports || [])
  //   .filter((r) => r.status === 'Verified')
  //   .map((r) => r.user_id);

  const hasAlreadyReviewed = reviews.some(
    (review) => review.user?.user_id === currentUser?.id
  );
  const canAddReview = !hasAlreadyReviewed;

  function handleClick() {
    if (!currentUser) {
      Swal.fire({
        title: 'You need to be logged in to add a review.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Login',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login?rep=review&issue_id=' + (issueId || issue?.issue_id));
        }
      });
    } else {
      navigate(`/reviews/add/${issueId || issue?.issue_id}`);
    }
  }

  return (
    <Box
      sx={{
        py: 5,
        // px: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
      }}
    >
      {/* Header with Add Review Button */}
      <MotionPaper
        elevation={2}
        sx={{
          width: '100%',
          // maxWidth: 950,
          p: 3,
          borderRadius: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: 'rgba(255,255,255,0.03)',
          backdropFilter: 'blur(6px)',
        }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h6" fontWeight="bold" color="success.main">
          Reviews ({reviews.length})
        </Typography>

        {canAddReview && (
          <Button
            variant="contained"
            color="success"
            size="small"
            sx={{
              borderRadius: 3,
              fontWeight: 'bold',
              textTransform: 'none',
              px: 3,
              py: 1.2,
              background: 'linear-gradient(45deg, #66bb6a, #26a69a)',
              boxShadow: '0 4px 12px rgba(38, 166, 154, 0.25)',
              '&:hover': {
                background: 'linear-gradient(45deg, #43a047, #00897b)',
              },
            }}
            onClick={handleClick}
          >
            💬 Review
          </Button>
        )}
        
      </MotionPaper>

      {/* Review Cards */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: { xs: '100vw', sm: '100%' },
            maxWidth: { sm: 950 },
          }}
        >
          <ReviewCards
            reviews={reviews}
            issue={issue}
            reload={reload}
            setReload={setReload}
          />
        </Box>
      </motion.div>

    </Box>
  );
};

export default IssueReviews;
